import Group from 'components/utils/Group'
import React, { useMemo } from 'react'
import DoublePointTakeoverLogo from './DoublePointTakeoverLogo'
import TextLink from 'LuxKit/TextLink'
import getLoyaltyProgramDisplayName from 'loyalty/selectors/getLoyaltyProgramDisplayName'
import { useAppSelector } from 'hooks/reduxHooks'
import useCurrentLoyaltyTier from 'loyalty/hooks/useCurrentLoyaltyTier'
import getHasLoyaltyAccount from 'loyalty/selectors/getHasLoyaltyAccount'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import styled from 'styled-components'
import useDoublePointsCampaignTier from '../hooks/useDoublePointsCampaignTier'
import LuxPlusExperienceDiscountOfferBanner from 'takeovers/luxplusExperienceDiscountTakeover/components/LuxPlusExperienceDiscountOfferBanner'
import { EXPERIENCE_ENABLED_REGIONS } from '../constants/societeDoublePointsTakeoverConstants'
import { getThemeClassName } from 'lib/theme/themeUtils'

const TextContent = styled.div`
  &.bronze {
    color: ${props => props.theme.palette.neutral.default.one};
  }

  &.silver {
    color: ${props => props.theme.palette.neutral.default.one};
  }

  &.gold {
    color: ${props => props.theme.palette.neutral.default.one};
  }

  &.platinum {
    color: ${props => props.theme.palette.product.loyalty.platinum.darkContrast};
  }
`

function DoublePointTakeoverBannerContent() {
  const currentRegionCode = useAppSelector(state => state.geo.currentRegionCode)
  const isExperienceEnabledRegion = EXPERIENCE_ENABLED_REGIONS.has(currentRegionCode)

  const loyaltyProgramName = getLoyaltyProgramDisplayName()
  const [tier, tierName, , nextTierName] = useCurrentLoyaltyTier()
  const hasLoyaltyAccount = useAppSelector(getHasLoyaltyAccount)
  const displayTierName = nextTierName ?? tierName
  const displayTier = useDoublePointsCampaignTier()

  const firstSentence = useMemo(() => {
    if (hasLoyaltyAccount) {
      if (tier === 'platinum') {
        return `Extend your ${displayTierName} ${loyaltyProgramName} status`
      }
      return `Fast-track to ${displayTierName} ${loyaltyProgramName} status`
    }
    return `Fast-track your ${loyaltyProgramName} status`
  }, [hasLoyaltyAccount, displayTierName, loyaltyProgramName, tier])

  const nonBoldText = 'Double status credits on all hotels, tours and cruises. Limited time only. '

  // Show LuxPlus Experience Discount banner for regions where experiences are available
  if (isExperienceEnabledRegion) {
    return <LuxPlusExperienceDiscountOfferBanner withCta />
  }

  return (
    <Group direction="horizontal" gap={12} verticalAlign="center" className={getThemeClassName({ mobile: 'default' })}>
      <DoublePointTakeoverLogo size="small" />
      <TextContent className={displayTier}>
        <CSSBreakpoint max="mobile">
          <Group direction="vertical" gap={0} verticalAlign="start">
            <b>{firstSentence}</b>
            <span>
              {nonBoldText}
              <TextLink wrap="no-wrap" weight="regular" to="/double-status-credits" colour="inherit">View all offers</TextLink>
            </span>
          </Group>
        </CSSBreakpoint>
        <CSSBreakpoint min="tablet">
          <><b>{firstSentence}</b>{' '}{nonBoldText}<TextLink wrap="no-wrap" to="/double-status-credits" colour="inherit">View all offers</TextLink></>
        </CSSBreakpoint>
      </TextContent>
    </Group>
  )
}

export default DoublePointTakeoverBannerContent
